import { fetchArticleBySlug } from 'core_main/api/articles';
import {
  ArticleCallbackResponse,
  GetArticleBySlugParameters,
} from 'core_main/sdk/get_articles/types';
import { createArticleCallbackResponse } from 'core_main/sdk/get_articles/helpers';

export const getArticleBySlug = (
  parameters: GetArticleBySlugParameters,
  cb?: (res: ArticleCallbackResponse | null, err?: Error) => void,
) => {
  return fetchArticleBySlug(parameters)
    .then((articleResponse) => {
      let callbackResponse: ArticleCallbackResponse | null = null;
      if (articleResponse) {
        callbackResponse = createArticleCallbackResponse(articleResponse);
      }

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
      return callbackResponse;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to get article', error);
    });
};
